module.exports = __webpack_public_path__ + "static/media/beerMark.e8a86127.svg";